import {
  defaultColors,
  pxToVw,
  generateUseGetCurrentPx,
  getExtendTheme,
  getTheme,
  myBoxShadowPlugin,
  myTextBorderPlugin,
} from "@becon-team/becon-fe-lib/my-tailwind-css";

export const myPlugins = [myBoxShadowPlugin(pxToVw), myTextBorderPlugin(pxToVw)];

export const useGetCurrentPx = generateUseGetCurrentPx({});

export const colors = {
  ...defaultColors,
  primary: {
    50: "#EBE7F4",
    100: "#dad6e4",
    200: "#b5acc9",
    300: "#9183af",
    400: "#6c5994",
    DEFAULT: "#473079",
    600: "#392661",
    700: "#2b1d49",
    800: "#1c1330",
    900: "#0e0a18",
  },
  secondary: {
    50: "#F9F2EF;",
    100: "#ffedcc",
    200: "#ffdb99",
    300: "#ffc966",
    400: "#ffb733",
    DEFAULT: "#ffa500",
    600: "#cc8400",
    700: "#996300",
    800: "#664200",
    900: "#332100",
  },
} as const;

export const sizes = {
  height: {
    "header-height": 48,
    "navigation-height": 64,
  },
} as const;

export const cssVariableSizes = {
  spacing: {
    "inner-padding": "var(--my-inner-padding)",
  },
};

export const theme = getTheme(pxToVw, colors);

export const extendTheme = getExtendTheme(pxToVw, sizes, cssVariableSizes, 1280);
